import type { Options } from "change-case";
import * as changeCase from "change-case";
const cases = [
    "camelCase",
    "capitalCase",
    "constantCase",
    "dotCase",
    "kebabCase",
    "noCase",
    "pascalCase",
    "pascalSnakeCase",
    "pathCase",
    "sentenceCase",
    "snakeCase",
] as const;
type Case = (typeof cases)[number];

const setCase = (toCase: Case, options?: Options) => (input: string) => {
    return changeCase[toCase]?.(input, options) || input;
};

const snakeCase = setCase("snakeCase");
const capitalCase = setCase("capitalCase");
const kebabCase = setCase("kebabCase");
const camelCase = setCase("camelCase");

const capitalizeFirst = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export {
    camelCase,
    capitalCase,
    capitalizeFirst,
    cases,
    kebabCase,
    setCase,
    snakeCase,
};
export type { Case };
